import type { StyleProp, ViewStyle } from "react-native";
import { Card, Divider } from "react-native-paper";
import HeaderCard from "../HeaderCard";

type Props = {
	children: React.ReactNode;
	title: string;
	subtitle: string;
	icon: string;
	actions?: React.ReactNode;
	onPress?: () => void;
	tooltip?: string;
	style?: StyleProp<ViewStyle>;
	contentStyle?: StyleProp<ViewStyle>;
	headerRight?: React.ReactNode;
	mode?: "elevated" | "outlined" | "contained";
};
const CardContainer = ({
	children,
	title,
	subtitle,
	icon,
	actions,
	onPress,
	tooltip,
	style,
	contentStyle,
	headerRight,
	mode,
}: Props) => {
	return (
		<Card
			onPress={onPress}
			style={style}
			contentStyle={contentStyle}
			mode={mode}
		>
			<HeaderCard
				tooltip={tooltip}
				title={title}
				subtitle={subtitle}
				icon={icon}
				headerRight={headerRight}
			/>
			<Divider />
			{children}
			{actions}
		</Card>
	);
};

export default CardContainer;
